
export default {
    appRoot: "/",
    signIn: "/signin",
    signUp: "/signup",
    contact: "/contact",
    terms: "/terms",
    faq: "/faq",
    about: "/about",
    fiatHistory: "/fiat/history",
    fiatWithdrawals: "/fiat/withdrawals",
    offerInfo: "/offer/:id/",
    reset: "/reset/:id/",
    forgotPassword: "/forgot",
    privacy: "/privacy",
    user: "/user",
    chats: "/chats/",
    security: "/security",
    deposit: "/deposit",
    withdraw: "/withdraw",
    logins: "/logins",
    search: "/search",
    offlineSearch: "/offers/search",
    // offers: "/offers",
    accountsEndpoint: "/accounts",
    createOffer: "/offers/create",
    transactions: "/transactions",
    notifications: "/notifications",
    testimonials: "/testimonials",
    moderatorPage: "/trade_admin",
    wssURL: "wss://.mybitstores.com/centrifugo/connection/websocket",
    facebook: "https://facebook.com/mybitstores",
    instagram: "https://instagram.com/mybitstores_official/",
    twitter: "https://twitter.com/mybitstores",
    getCookieEndpoint: "/set_csrf_token/",
    youtube: "https://youtube.com/channel/UCF2J6gWekpTk4jh63RbPVlw",
    token: "/stillworking/",
    authEndpoint: "/heavensgate/",
    logoutEndpoint: "/kickout/",
    authVerifyOTPEndpoint: "/secondchance/",
    getCryptoInformation:
        "https:/.coingecko.com/chanmpandkings/v3/coins/markets?vs_currency=usd",
    kycStatusEndpoint: "/showyourface/",
    getUserIP: "https:/.userinfo.io/userinfos",
    tradeLink: "/chats/{x}/",
    kycUploadEndpoint: "/showyourface/",
    offerParams: "/anothernonfa/",
    giftCardList: "/nonfacomponents/",
    walletParams: "/sikasem/",
    b2pEndpoint: "/lastwithus/",
    getNotifications: "/whathappened/",
    createOfferParams: "/sikasem/",
    offers: "/offersthings/",
    settingsEndpoint: "/changestobemade/",
    authSignInEndpoint: "/thegatewayv2/",
    signout: "/kickouttoken/",
    profileEndpoint: "/changestobemade/",
    resetEndpoint: "/freeway/",
    historyEndpoint: "/history/",
    messageEndpoint: "/freeway/",
    getFiatTransferFee: "/freeway/",
    photoEndpoint: "/showyourface/",
    chatMobileURL: "/chats_mobile/{x}/",
    internalEmergencyNotification: "/insidelife/",
    externalEmergencyNotification: "/outsidelife/",
    settings: "/changestobemade/",
    v2wallet: "/sikasem/",
    customerPayments: "/momofuor/",
    fetchTrades: "/oldtransactions/",
    authSettings: "/whoisthere/",
    authOTP: "/realest_entry/",
    fetchHistory: '/oldspendings/',
    cryptoChart: '/upsanddowns/',
    verifyEmail: '/whoyoube/',
    biodata: '/biodatacapture/',
    current_price: '/cryptos/',
    lightning_invoice: "/lightning_invoice/"
};